import React, { Component } from "react";
import { Tag, Tooltip, Popconfirm, message } from "antd";
import { EditOutlined, CopyOutlined, CheckCircleOutlined, StopOutlined, FileProtectOutlined } from "@ant-design/icons";
import { ButtonItem, SegmentedItem, TableItem } from "../../../../Components/Items";
import { cmmsPost, OPCIONES_ESTADO } from "../cmmsComun";
import ModalEjemplosCertificado from "./ModalEjemplosCertificado";

// Plantillas de certificado (una por tipo de equipo, como las hojas del F-SE-14).
class PlantillasCertificado extends Component {
    state = { loading: false, plantillas: [], valor: 1, ejemplos: false };

    componentDidMount() {
        this.consultar();
    }

    consultar = async () => {
        this.setState({ loading: true });
        try {
            const res = await cmmsPost(this.props, "selectPlantillasCertificadoCMMS", { valor: this.state.valor });
            this.setState({ plantillas: res.data.success === 2 ? res.data.plantillas : [] });
        } catch (error) {
            console.log(error);
            message.error("No se pudieron consultar las plantillas");
        } finally {
            this.setState({ loading: false });
        }
    };

    accion = async (ruta, body, exito) => {
        const res = await cmmsPost(this.props, ruta, body);
        if (res.data.success === 2) {
            if (exito) message.success(exito);
            this.consultar();
        } else message.error(res.data.message || "No se pudo completar la acción");
    };

    abrir = (id) => this.props.history.push("/panel/cmmsPlantillaCertificado", { id });

    render() {
        const columns = [
            { title: "Clave", dataIndex: "clave", key: "clave", buscar: "clave", width: 170 },
            { title: "Certificado", dataIndex: "nombre", key: "nombre", buscar: "nombre", sorter: (a, b) => (a.nombre || "").localeCompare(b.nombre || "") },
            {
                title: "Tipos de activo",
                dataIndex: "tiposNombres",
                key: "tiposNombres",
                render: (v) => ((v || []).length ? v.map((n) => <Tag key={n}>{n}</Tag>) : <span style={{ color: "#9aa7b4" }}>Ninguno (se elige a mano)</span>),
            },
            { title: "Vigencia", dataIndex: "vigenciaMeses", key: "vigenciaMeses", width: 90, render: (v) => `${v} meses` },
            { title: "Emitidos", dataIndex: "emitidos", key: "emitidos", width: 90, align: "right" },
            {
                title: "Acción",
                key: "acciones",
                fixed: "right",
                align: "center",
                width: 130,
                onCell: () => ({ className: "acciones-sin-hover", style: { textAlign: "center", padding: "4px" } }),
                render: (r) => (
                    <div className="acciones-container">
                        <Tooltip title="Editar">
                            <ButtonItem type="default" size="small" cyan icon={<EditOutlined />} onClick={() => this.abrir(r._id)} />
                        </Tooltip>
                        <Tooltip title="Duplicar (para otra marca o modelo)">
                            <ButtonItem type="default" size="small" blanco icon={<CopyOutlined />} onClick={() => this.accion("duplicarPlantillaCertificadoCMMS", { id: r._id }, "Plantilla duplicada")} />
                        </Tooltip>
                        <Popconfirm
                            title={r.estado === 1 ? "¿Deshabilitar? Ya no se podrá usar en certificados nuevos." : "¿Habilitar de nuevo?"}
                            onConfirm={() => this.accion("cambiarEstadoPlantillaCertificadoCMMS", { id: r._id, estado: r.estado === 1 ? 2 : 1 })}
                            okText="Sí"
                            cancelText="No"
                        >
                            <Tooltip title={r.estado === 1 ? "Deshabilitar" : "Habilitar"}>
                                {r.estado === 1 ? <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} /> : <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />}
                            </Tooltip>
                        </Popconfirm>
                    </div>
                ),
            },
        ];
        return (
            <>
                <div className="cmms-filtros" style={{ justifyContent: "space-between" }}>
                    <SegmentedItem options={OPCIONES_ESTADO} value={this.state.valor} onChange={(valor) => this.setState({ valor }, this.consultar)} />
                    <span style={{ display: "flex", gap: 6 }}>
                        <ButtonItem type="default" icon={<FileProtectOutlined />} onClick={() => this.setState({ ejemplos: true })}>
                            Cargar formatos F-SE-14
                        </ButtonItem>
                        <ButtonItem type="primary" olivo onClick={() => this.props.history.push("/panel/cmmsPlantillaCertificado", {})}>
                            Nueva plantilla
                        </ButtonItem>
                    </span>
                </div>
                <TableItem
                    loading={this.state.loading}
                    size="small"
                    dataSource={this.state.plantillas}
                    columns={columns}
                    rowKey="_id"
                    pagination={true}
                    locale={{ emptyText: "Sin plantillas: cargue los formatos F-SE-14 o cree una nueva." }}
                    onRow={(r) => ({ onDoubleClick: () => this.abrir(r._id) })}
                />
                <ModalEjemplosCertificado {...this.props} visible={this.state.ejemplos} onClose={(ok) => this.setState({ ejemplos: false }, () => ok && this.consultar())} />
            </>
        );
    }
}

export default PlantillasCertificado;
